 <template>
    <img v-if="currentPicture && isPhotoLocal(currentPicture)"
        class="rounded-full w-28 h-28" :src="getFileUrl(currentPicture)"
    />
    <img v-else class="rounded-full w-28 h-28"
        :src="user.profile_photo_url"
        :alt="user.profile_photo_url"
    />
</template>

<script>
    import FilesActions from '@/Mixins/FilesActions'
    
    export default {
        mixins: [FilesActions],

        props: {
            user: Object,
            currentPicture: Object
        },
        mounted() {
            console.log(this.user)
        }
    }
</script>
